module.exports = __webpack_public_path__ + "static/media/Logo.69f0dfd3.png";